// Consolidated Mock Data for MFU Admin Application

// ข้อมูลผู้ใช้สำหรับการล็อกอิน
export const mockUsers = [
  {
    id: 1,
    username: "3469900178051",
    password: "0813186700",
    role: "admin",
    fullName: "ผู้ดูแลระบบ",
    email: "admin@dietz.com",
    department: "IT",
    lastLogin: null,
    isActive: true
  }
];

// ข้อมูล Templates สำหรับ healthbook
export const templateData = {
  'ตรวจสุขภาพทั่วไป': {
    id: 1,
    templateName: 'ตรวจสุขภาพทั่วไป',
    createdBy: 'นพ. นพพงศ์ ถนอมศรี',
    tags: ['ตรวจสุขภาพ', 'ปีล่าสุด'],
    gender: 'ทั้งสองเพศ',
    ageRange: '18-60',
    parameters: ['CHO', 'TRI', 'HDL', 'LDL'],
    normalValues: ['< 200', '< 150', '> 40', '< 100'],
    setValues: ['240 - 260', '160 - 189', '20 - 35', '200 - 499']
  },
  'ตรวจไขมันในเลือด': {
    id: 2,
    templateName: 'ตรวจไขมันในเลือด',
    createdBy: 'นพ. นพพงศ์ ถนอมศรี',
    tags: ['ไขมัน', 'คอเลสเตอรอล'],
    gender: 'ทั้งสองเพศ',
    ageRange: '25-65',
    parameters: ['CHO', 'TRI', 'HDL', 'LDL'],
    normalValues: ['< 200', '< 150', '> 40', '< 100'],
    setValues: ['240 - 260', '160 - 189', '20 - 35', '200 - 499']
  },
  'ตรวจเบาหวาน': {
    id: 3,
    templateName: 'ตรวจเบาหวาน',
    createdBy: 'นพ. สมหญิง ดูแลดี',
    tags: ['เบาหวาน', 'น้ำตาล'],
    gender: 'ทั้งสองเพศ',
    ageRange: '30-70',
    parameters: ['FBS', 'HbA1C', 'GLU'],
    normalValues: ['70-100', '< 7.0', '< 140'],
    setValues: ['126-200', '7.0-9.0', '140-200']
  }
};

// ข้อมูลบันทึกสุขภาพสำหรับ healthbook
export const healthRecordsData = [
  {
    id: 1,
    no: '001',
    date: '13/05/2025',
    patientName: 'นายสมชาย ใจดี',
    gender: 'ชาย',
    age: 45,
    diseases: 'ความดัน, ไขมันในเลือดสูง',
    hn: 'HN-xxxxxx',
    parameters: [
      { name: 'CHO', result: '220', normal: '<200' },
      { name: 'TRI', result: '180', normal: '<150' },
      { name: 'HDL', result: '35', normal: '>40' },
      { name: 'LDL', result: '140', normal: '<100' },
      { name: 'CBC', result: 'xxx', normal: 'xxx' },
      { name: 'FBS', result: 'xxx', normal: 'xxx' },
      { name: 'SGPT', result: 'xxx', normal: 'xxx' },
      { name: 'SGOT', result: 'xxx', normal: 'xxx' },
      { name: 'BUN', result: 'xxx', normal: 'xxx' },
      { name: 'Creatinine', result: 'xxx', normal: 'xxx' }
    ],
    templates: ['ตรวจสุขภาพทั่วไป', 'ตรวจไขมันในเลือด'],
    status: 'รอการอนุมัติ',
    isApproved: false
  },
  {
    id: 2,
    no: '002',
    date: '13/05/2025',
    patientName: 'นางสาวสมหญิง รักษาดี',
    gender: 'หญิง',
    age: 38,
    diseases: 'เบาหวาน',
    hn: 'HN-xxxxxx',
    parameters: [
      { name: 'FBS', result: '150', normal: '70-100' },
      { name: 'HbA1C', result: '8.5', normal: '<7.0' },
      { name: 'CHO', result: 'xxx', normal: 'xxx' },
      { name: 'TRI', result: 'xxx', normal: 'xxx' },
      { name: 'HDL', result: 'xxx', normal: 'xxx' },
      { name: 'LDL', result: 'xxx', normal: 'xxx' },
      { name: 'CBC', result: 'xxx', normal: 'xxx' },
      { name: 'SGPT', result: 'xxx', normal: 'xxx' },
      { name: 'SGOT', result: 'xxx', normal: 'xxx' },
      { name: 'BUN', result: 'xxx', normal: 'xxx' },
      { name: 'Creatinine', result: 'xxx', normal: 'xxx' }
    ],
    templates: ['ตรวจเบาหวาน'],
    status: 'อนุมัติและจัดส่งผลการตรวจสุขภาพแล้ว',
    isApproved: true
  }
];

// ข้อมูล Template Records สำหรับหน้า template
export const templateRecordsData = [
  {
    id: 1,
    no: '001',
    templateName: 'ตรวจสุขภาพทั่วไป',
    createdBy: 'นพ. นพพงศ์ ถนอมศรี',
    tags: ['ตรวจสุขภาพ', 'ปีล่าสุด'],
    gender: 'ทั้งสองเพศ',
    ageRange: '18-60',
    parameters: ['CHO', 'TRI', 'HDL', 'LDL'],
    normalValues: ['xxx', 'xxx', 'xxx', 'xxx'],
    setValues: ['xxx', 'xxx', 'xxx', 'xxx'],
    isActive: true
  },
  {
    id: 2,
    no: '002',
    templateName: 'ตรวจสุขภาพพิเศษ',
    createdBy: 'นพ. สมหญิง ดูแลดี',
    tags: ['พิเศษ', 'สตรี'],
    gender: 'เพศหญิง',
    ageRange: '25-45',
    parameters: ['GLU', 'BUN', 'CREA'],
    normalValues: ['xxx', 'xxx', 'xxx'],
    setValues: ['xxx', 'xxx', 'xxx'],
    isActive: false
  },
  {
    id: 3,
    no: '003',
    templateName: 'ตรวจหัวใจ',
    createdBy: 'นพ. นพพงศ์ ถนอมศรี',
    tags: ['หัวใจ', 'ความดัน'],
    gender: 'เพศชาย',
    ageRange: '40-70',
    parameters: ['ECG', 'EKG', 'BP'],
    normalValues: ['xxx', 'xxx', 'xxx'],
    setValues: ['xxx', 'xxx', 'xxx'],
    isActive: true
  }
];

// ข้อมูล Activity Log สำหรับหน้า template
export const activityLogData = [
  {
    date: '15/06/2025',
    time: '14.30 น.',
    template: 'ตรวจสุขภาพทั่วไป',
    createdBy: 'นพ. นพพงศ์ ถนอมศรี',
    event: 'แก้ไข Template'
  },
  {
    date: '10/06/2025',
    time: '10.15 น.',
    template: 'ตรวจสุขภาพพิเศษ',
    createdBy: 'นพ. สมหญิง ดูแลดี',
    event: 'สร้าง Template'
  },
  {
    date: '08/06/2025',
    time: '16.45 น.',
    template: 'ตรวจหัวใจ',
    createdBy: 'นพ. นพพงศ์ ถนอมศรี',
    event: 'ลบ Template'
  }
];

// ข้อมูลตัวอย่าง template สำหรับการแก้ไข
export const sampleTemplateData = {
  templateName: "ตรวจสุขภาพผู้สูงอายุ",
  createdBy: "นพ. สมชาย ใจดี",
  tags: ["ผู้สูงอายุ", "พันธุกรรม", "เบาหวาน"],
  gender: "both",
  ageRange: [60, 80],
  selectedParameters: [
    { name: 'CHO', unit: 'mg/dL', normalRange: [0, 300], normalValue: '<200', defaultRange: [180, 240] },
    { name: 'TRI', unit: 'mg/dL', normalRange: [0, 500], normalValue: '<150', defaultRange: [100, 180] },
    { name: 'HDL', unit: 'mg/dL', normalRange: [20, 100], normalValue: '>40', defaultRange: [30, 60] },
    { name: 'GLU', unit: 'mg/dL', normalRange: [50, 300], normalValue: '70-100', defaultRange: [90, 130] }
  ],
  parameterRanges: {
    'CHO': [180, 240],
    'TRI': [100, 180],
    'HDL': [30, 60],
    'GLU': [90, 130]
  }
};

// ข้อมูลพารามิเตอร์ทั้งหมดสำหรับ CreateTemplate
export const allParameters = [
  { name: 'CHO', unit: 'mg/dL', normalRange: [0, 300], normalValue: '<200', defaultRange: [100, 200] },
  { name: 'TRI', unit: 'mg/dL', normalRange: [0, 500], normalValue: '<150', defaultRange: [50, 150] },
  { name: 'HDL', unit: 'mg/dL', normalRange: [20, 100], normalValue: '>40', defaultRange: [40, 80] },
  { name: 'LDL', unit: 'mg/dL', normalRange: [0, 250], normalValue: '<100', defaultRange: [70, 100] },
  { name: 'CBC', unit: 'cells/μL', normalRange: [3000, 15000], normalValue: '4000-10000', defaultRange: [4000, 10000] },
  { name: 'Cre', unit: 'mg/dL', normalRange: [0.3, 3.0], normalValue: '0.6-1.2', defaultRange: [0.6, 1.2] },
  { name: 'BUN', unit: 'mg/dL', normalRange: [5, 50], normalValue: '8-20', defaultRange: [8, 20] },
  { name: 'GLU', unit: 'mg/dL', normalRange: [50, 300], normalValue: '70-100', defaultRange: [70, 100] },
  { name: 'ALT', unit: 'U/L', normalRange: [0, 100], normalValue: '<40', defaultRange: [10, 40] },
  { name: 'AST', unit: 'U/L', normalRange: [0, 100], normalValue: '<40', defaultRange: [10, 40] }
];

// ฟังก์ชันสำหรับตรวจสอบการล็อกอิน
export const validateLogin = (username, password) => {
  const user = mockUsers.find(
    (u) => u.username === username && u.password === password && u.isActive
  );
  
  if (user) {
    user.lastLogin = new Date().toISOString();
    
    return {
      success: true,
      user: {
        id: user.id,
        username: user.username,
        fullName: user.fullName,
        email: user.email,
        role: user.role,
        department: user.department,
        lastLogin: user.lastLogin
      },
      message: `ยินดีต้อนรับ ${user.fullName}`
    };
  }
  
  return {
    success: false,
    user: null,
    message: "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง"
  };
};

// ฟังก์ชันตรวจสอบสิทธิ์ตาม role
export const checkPermission = (userRole, requiredRole) => {
  const roleHierarchy = {
    guest: 1,
    demo: 2,
    user: 3,
    manager: 4,
    admin: 5
  };
  
  return roleHierarchy[userRole] >= roleHierarchy[requiredRole];
};

// ฟังก์ชันจำลองการรีเซ็ตรหัสผ่าน
export const resetPassword = (username) => {
  const user = mockUsers.find((u) => u.username === username);
  
  if (user) {
    return {
      success: true,
      message: `ลิงก์รีเซ็ตรหัสผ่านถูกส่งไปยัง ${user.email} แล้ว`
    };
  }
  
  return {
    success: false,
    message: "ไม่พบชื่อผู้ใช้ในระบบ"
  };
};

// ข้อมูล AI Recommendations สำหรับการแนะนำสุขภาพ
export const aiRecommendations = {
  doctorAdvice: "สิ่งสำคัญคือ พบแพทย์ตามนัดอย่าง สม่ำเสมอ และ ทานยาตามที่แพทย์สั่ง อย่างเคร่งครัด ห้ามหยุดยาเองเด็ดขาด นอกจากนี้ควร งดเครื่องดื่มแอลกอ ฮอล์และการสูบบุหรี่ เพื่อลดความเสี่ยง ภาวะแทรกซ้อน และควรเรียนรู้เกี่ยวกับ โรค เพื่อดูแลตัวเองได้อย่างถูกต้อง และมีประสิทธิภาพ",
  dietAdvice: "ควร ลดอาหารรสจัด โดยเฉพาะรสเค็ม หวาน และมัน เช่น ขนมหวาน น้ำอัดลม และอาหารทอด เพิ่มผักใบเขียวและ ผลไม้รสไม่หวาน และ เลือกทานคาร์ โบไฮเดรตเชิงซ้อน เช่น ข้าวกล้อง และ ขนมปังโฮลวีท ควร ลดเนื้อสัตว์ติดมัน และหันมาทานปลา อกไก่ หรือเต้าหู้แทน",
  exerciseAdvice: "ควร ออกกำลังกายสม่ำเสมอ อย่างน้อย วันละ 30 นาที 3-5 วันต่อสัปดาห์ เช่น เดินเร็ว ปั่นจักรยาน หรือว่ายน้ำ เลือก ประเภทการออกกำลังกายที่เหมาะสม และ ไม่หักโหมจนเกินไป ควรเริ่มต้น จากเบาๆ แล้วค่อยๆ เพิ่มความหนักขึ้น การออกกำลังกายจะช่วยควบคุม น้ำหนักและระดับน้ำตาลในเลือดได้ดี",
  sleepAdvice: "ควร นอนหลับให้เพียงพอ วันละ 7-8 ชั่วโมง และ เข้านอน-ตื่นนอนให้เป็น เวลา ทุกวัน เพื่อให้ร่างกายมีระบบการ ทำงานที่สม่ำเสมอ ควร จัดสภาพแวด ล้อมในห้องนอนให้เหมาะสม และ งดเล่น โทรศัพท์ หรือดูทีวีก่อนนอนอย่างน้อย 30 นาที การนอนที่มีคุณภาพช่วยลด ความเครียดและความดันโลหิตได้"
};

// ข้อมูลประวัติการฉีดวัคซีน
export const vaccinationRecords = [
  {
    id: 1,
    patientName: 'นายสมชาย ใจดี',
    hn: 'HN-001234',
    records: [
      {
        date: '15',
        month: 'มกราคม',
        year: '2568',
        vaccineName: 'วัคซีนไข้หวัดใหญ่'
      },
      {
        date: '20',
        month: 'มีนาคม',
        year: '2568',
        vaccineName: 'วัคซีนป้องกันโรคคอตีบ'
      },
      {
        date: '10',
        month: 'พฤษภาคม',
        year: '2568',
        vaccineName: 'วัคซีนป้องกันโรคบาดทะยัก'
      }
    ]
  },
  {
    id: 2,
    patientName: 'นางสาวสมหญิง รักษาดี',
    hn: 'HN-001235',
    records: [
      {
        date: '25',
        month: 'กุมภาพันธ์',
        year: '2568',
        vaccineName: 'วัคซีนไข้หวัดใหญ่'
      },
      {
        date: '12',
        month: 'เมษายน',
        year: '2568',
        vaccineName: 'วัคซีนป้องกันโรคตับอักเสบบี'
      },
      {
        date: '18',
        month: 'มิถุนายน',
        year: '2568',
        vaccineName: 'วัคซีนป้องกันโรคปอดบวม'
      }
    ]
  }
];

// ข้อมูลรายละเอียดการนัดฉีดวัคซีน
export const vaccinationDetails = [
  {
    patientName: 'นายสมชาย ใจดี',
    details: 'ผู้ป่วยมีอาการแพ้ยาบางชนิด ควรสังเกตอาการหลังการฉีดวัคซีน และให้พักสังเกตอาการอย่างน้อย 30 นาที'
  },
  {
    patientName: 'นางสาวสมหญิง รักษาดี',
    details: 'ผู้ป่วยเป็นเบาหวาน ควรติดตามระดับน้ำตาลในเลือดก่อนและหลังการฉีดวัคซีน พร้อมแจ้งแพทย์หากมีอาการผิดปกติ'
  },
  {
    patientName: 'นายสมศักดิ์ ใจดี',
    details: 'ผู้ป่วยมีประวัติการแพ้อาหารทะเล ควรระวังการแพ้วัคซีน และเตรียมยาแก้แพ้ไว้พร้อมใช้'
  }
];

// ข้อมูลสำหรับทดสอบ - บัญชี admin เท่านั้น
export const testCredentials = [
  { username: "admin", password: "admin123", description: "ผู้ดูแลระบบ" }
];

// ข้อมูล Campaign
export const campaignData = [
  {
    id: 1,
    code: '688',
    company: 'xxx',
    name: 'xxx',
    consultants: ['xxxx', 'xxxx'],
    duration: '365 วัน',
    cost: '0.00',
    promoCode: '',
    startDate: '0000-00-00',
    endDate: '0000-00-00'
  },
  {
    id: 2,
    code: '687',
    company: 'xxx',
    name: 'xxx',
    consultants: ['xxxx'],
    duration: '365 วัน',
    cost: '0.00',
    promoCode: '',
    startDate: '0000-00-00',
    endDate: '0000-00-00'
  },
  {
    id: 3,
    code: '686',
    company: 'xxx',
    name: 'xxx',
    consultants: ['xxx', 'xxxx', 'xxx'],
    duration: '365 วัน',
    cost: '0.00',
    promoCode: '',
    startDate: '0000-00-00',
    endDate: '0000-00-00'
  },
  {
    id: 4,
    code: '685',
    company: 'xxx',
    name: 'xxx',
    consultants: ['xxxx'],
    duration: '365 วัน',
    cost: '0.00',
    promoCode: '',
    startDate: '0000-00-00',
    endDate: '0000-00-00'
  },
  {
    id: 5,
    code: '684',
    company: 'xxx',
    name: 'xxx',
    consultants: ['xxx', 'xxx'],
    duration: '365 วัน',
    cost: '0.00',
    promoCode: '',
    startDate: '0000-00-00',
    endDate: '0000-00-00'
  }
];